import { gql } from 'apollo-boost';

export const LOGIN_CUSTOMER_GQL = gql`
  query doLoginCustomer($email: String!, $password: String!) {
    loginCustomer(email: $email, password: $password)
  }
`;
